import { CoverStyle, COVER_STYLES } from "@/types/agendaCustomization";
import { cn } from "@/lib/utils";

interface CoverStyleSelectorProps {
  selectedStyle: CoverStyle;
  onStyleChange: (style: CoverStyle) => void;
}

export const CoverStyleSelector = ({
  selectedStyle,
  onStyleChange,
}: CoverStyleSelectorProps) => {
  return (
    <div className="space-y-3">
      <label className="text-sm font-serif text-gray-700 dark:text-gray-300">
        Estilo de Cubierta
      </label>
      <div className="flex gap-3">
        {COVER_STYLES.map((style) => (
          <button
            key={style.value}
            onClick={() => onStyleChange(style.value)}
            className={cn(
              "flex-1 border rounded-lg p-3 transition-all hover:shadow-md",
              selectedStyle === style.value
                ? "border-primary border-2 shadow-md bg-primary/5"
                : "border-gray-300 dark:border-gray-600 hover:border-gray-400"
            )}
          >
            {style.imageUrl && (
              <div className="w-full h-20 mb-2 rounded overflow-hidden bg-gray-100">
                <img
                  src={style.imageUrl}
                  alt={style.label}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <span className="text-sm font-medium">{style.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
